// extracted by mini-css-extract-plugin
export var container = "_v7-0";
export var table = "_v7-2";
export var tableWrapper = "_v7-1";